import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  GET_VENDOR_RATINGS_REVIEWS,
  GET_VENDOR_RATINGS_COUNT,
} from "../../types";

// import Alert from "react-s-alert";

import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";

/***************************************
 * @DESC - GET ALL RATING REVIEW
 *****************************************/
export const get_all_rating_review =
  (vendor_id, token, type) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_all_rating_review = await axios.get(
        `${serverApi}/review-rating?vendor_id=${vendor_id}&type=${type}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_all_rating_review.data) {
        dispatch({
          type: GET_VENDOR_RATINGS_REVIEWS,
          payload: get_all_rating_review.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET ALL RATING REVIEW COUNT
 *****************************************/
export const get_all_rating_review_count =
  (restaurantId) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_all_rating_review_count = await axios.get(
        `${serverApi}/review-rating/${restaurantId}?review_stars=true&vendor=true`
      );
      if (get_all_rating_review_count.status === 200) {
        dispatch({
          type: GET_VENDOR_RATINGS_COUNT,
          payload: get_all_rating_review_count.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
